import { Block } from '@klp/design/Block';
import React from 'react';
import type { PropsWithChildren } from 'react';

export const MainNavigation: React.FC<PropsWithChildren<unknown>> = ({
    children,
}) => {
    return <Block marginBottom="compact">{children}</Block>;
};
